const reads = new Map<string, Promise<unknown>>();

export const dedupe = <TResult>(key: string, read: () => Promise<TResult>): Promise<TResult> => {
  const pending = reads.get(key) as Promise<TResult> | undefined;

  if (pending) {
    return pending;
  }

  const request = read().catch((error) => {
    reads.delete(key);
    throw error;
  });

  reads.set(key, request);

  return request;
};

export const clearCmsCache = () => reads.clear();
